import React from 'react'
import Footer from '../Components/Footer'

const Renal = () => {
  return (
    <>
    <br />
    <center><h1>Renal  Stones</h1></center>
    <div className='cronic'>
        <p>Renal artery stenosis is narrowing of the one or both of renal arteries. It is the major cause of hypertension and according to some reports is the cause of hypertension in 1% to 10% of the 50 million people in the United States. Atherosclerosis or fibromuscular dysplasia most often cause it.
        </p>
    </div>
    <Footer />
</>
  )
}

export default Renal